<template>
  <TableHeaderCellDropdown @clear="onClear"
                           @open="onOpen">
    <template v-slot:trigger-text>
      {{ name }}
    </template>
    <template v-slot:trigger-ico>
      <BaseSvg name="ico-loupe"
               class="table-header-cell-dropdown__trigger-loupe"/>
    </template>
    <template v-if="selectedIds.length"
              v-slot:selected>
      <span class="table-header-cell-dropdown__selected-text">
        {{ selectedIds.length }}
      </span>
    </template>
    <template v-slot:content="">
      <BasePreloader v-if="pending"/>
      <div class="table-header-cell-dropdown__options  filter-checkbox">
        <div class="filter-checkbox__input">
          <BaseInput v-model="search"
                     autofocus
                     @input="onSearchInput"
                     :placeholder="$tStatistic('Start typing a name')"/>
          <BaseSvg name="ico-loupe"/>
        </div>
        <ul class="filter-checkbox__list">
          <li v-for="item in items"
              :key="item.id ||  item.resume_id"
              class="filter-checkbox__item">
            <BaseCheckbox :checked="selectedIds.includes(String(item.id ||  item.resume_id))"
                          @input="onChange($event, item.id ||  item.resume_id)"
                          class="filter-checkbox__item-checkbox  _user">
              <template v-slot:label>
                <picture v-if="item.avatar"
                         class="filter-checkbox__item-checkbox-candidate-img">
                  <img :src="item.avatar"
                       alt="User"/>
                </picture>
                <div v-else
                     :style="{backgroundColor: getColor()}"
                     class="filter-checkbox__item-checkbox-candidate-img  _placeholder">
                  {{ getAbbr(item.lastname, item.firstname) }}
                </div>
                <span class="filter-checkbox__item-checkbox-user-name">
                  {{ item.fullname }}
                </span>
              </template>
            </BaseCheckbox>
          </li>
        </ul>
      </div>
    </template>
  </TableHeaderCellDropdown>
</template>

<script>
  import {http} from '@/axios'
  import {CancelToken, isCancel} from 'axios'
  import TableHeaderCellDropdown from '@/components/TableHeaderCellDropdown'

  const colors = ['#9c9bb6', '#d38282', '#e4bf68']
  let colorIndex = 0


  export default {
    name: 'StatisticsPageTableHeadCellPartner',
    components: {
      TableHeaderCellDropdown
    },
    inject: {
      statisticPage: {
        default: () => ({ additionalQueryParams: {} }),
      },
    },
    props: {
      name: String,
      routeKey: String,
      apiLink: String,
    },
    data() {
      return {
        pending: false,
        loaded: false,
        lastSearch: '',
        cancel: null,
        items: [],
        search: '',
        searchTimeout: null,
      }
    },
    computed: {
      selectedIds() {
        const candidates = this.$route.query[this.routeKey] || []
        return Array.isArray(candidates) ? candidates : [candidates]
      },
      selectedItems() {
        const ids = this.selectedIds
        return this.items.filter(item => ids.includes(String(item.id || item.resume_id)))
      }
    },
    methods: {
      onOpen() {
        this.load()
      },
      onSearchInput() {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
          this.load();
        }, 500);
      },
      load() {
        if (this.loaded && this.lastSearch === this.search) return

        if (this.cancel) {
          this.cancel()
          this.cancel = null
        }

        this.pending = true

        const search = this.search

        http.get(this.apiLink, {
          params: {
            q: search,
            alpha: this.statisticPage.additionalQueryParams.alpha,
          },
          cancelToken: new CancelToken((c) => {
            this.cancel = c;
          })
        })
            .then(({data}) => {
              this.items = data.data
              this.lastSearch = search
              this.loaded = true

              this.pending = false
            })
            .catch(e => {
              if (isCancel(e)) {
                return
              }
              this.pending = false
            })
      },
      onChange(value, id) {
        let ids = [...this.selectedIds]

        if (value) {
          ids.push(String(id))
        } else {
          ids = ids.filter(i => i !== String(id))
        }

        const query = {
          ...this.$route.query,
        }

        if (ids.length) {
          query[this.routeKey] = ids
        } else {
          delete query[this.routeKey]
        }

        this.$router.push({
          query
        }).catch(() => ({}))
      },
      onClear() {
        const query = {
          ...this.$route.query,
        }

        delete query[this.routeKey]

        this.$router.push({
          query
        }).catch(() => ({}))
      },
      getColor() {
        if (colors.length === colorIndex) {
          colorIndex = 0
        }

        const color = colors[colorIndex]
        colorIndex++

        return color
      },
      getAbbr(first, second) {
        return (first && first[0] || '-') + (second && second[0] || '-')
      }
    }
  }
</script>

<style lang="less">

</style>
